// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__JrcmX","tab":"Tabs_tab__3Ms64","tabActive":"Tabs_tabActive__33j2c"};